module.exports = __webpack_public_path__ + "static/media/Spade.bc558f85.svg";